export default __webpack_public_path__ + "static/media/b2.90bdb59f.jpg";